import { render, staticRenderFns } from "./ClearManually.vue?vue&type=template&id=47bbee80&"
import script from "./ClearManually.vue?vue&type=script&lang=js&"
export * from "./ClearManually.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports